import React from 'react';

// Mobile "Find person" box at the top of the add-guest sheet. Logic: usePeopleSearch (vm.people).
export default function PeopleSearchMobile({ vm }) {
  const { q, setQ, results, loading, pick } = vm.people;
  return (
    <div className="people-search people-search-mobile">
      <input type="search" value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 Find a known person — name or number" />
      {(loading || results.length > 0 || q.trim().length >= 2) && (
        <div className="people-search-results">
          {loading && <div className="muted">Searching…</div>}
          {!loading && results.length === 0 && <div className="muted">Nobody found.</div>}
          {results.map(p => (
            <button key={p.key} type="button" onClick={() => pick(p)}>
              <strong>{[p.Surname, p.GuestName].filter(Boolean).join(' ')}</strong>
              <span className="muted">{[p.MobileNumber, p.note].filter(Boolean).join(' · ')}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
